define('v3/Common/Services/intentsService',[], function () {
	function Registration (action, options, callback) {
		this.action = action;
		this.invoke = function (data) {
			if (callback) callback(data);
		};
	}

	var registeredIntents = {};

	var self = {};
	self.registerIntentHandler = function (action, options, callback) {
		if (!(action in registeredIntents)) {
			registeredIntents[action] = [];
		}
		registeredIntents[action].push(new Registration(action, options, callback));
	};
	self.broadcastIntent = function (action, data) {
		if (action in registeredIntents) {
			var registrations = registeredIntents[action];
			for (var i = 0; i < registrations.length; i++) {
				registrations[i].invoke(data);
			}
		} else {
			console.info('Broadcast received for action', action, 'but no handlers were registered for it.');
		}
	};
	return self;
});

